import {
  CheckboxField,
  DatePickerField,
  InputField,
  SelectField,
} from "@/features/FormCard/Fields";
import { Control } from "react-hook-form";
import {
  countries,
  fieldsBySection,
  OpenFundFieldConfig,
  sectionLabels,
} from "./open_fund_fields_config";

interface OpenFundFieldsSectionProps {
  control: Control<any>;
}

const renderField = (field: OpenFundFieldConfig, control: Control<any>) => {
  const commonProps = {
    name: field.code,
    label: field.label,
    control,
  };

  switch (field.type) {
    case "boolean":
      return <CheckboxField key={field.code} {...commonProps} />;

    case "number":
      return <InputField key={field.code} {...commonProps} type="number" />;

    case "datepicker":
      return <DatePickerField key={field.code} {...commonProps} />;

    case "country":
      return (
        <SelectField
          key={field.code}
          {...commonProps}
          options={countries}
          allow_empty_option
        />
      );

    case "countries":
      return <InputField key={field.code} {...commonProps} />;

    case "string":
    default:
      return <InputField key={field.code} {...commonProps} />;
  }
};

export function OpenFundFieldsSection({ control }: OpenFundFieldsSectionProps) {
  return (
    <>
      {Object.entries(fieldsBySection).map(([sectionKey, fields]) => (
        <div key={sectionKey} className="mb-6">
          <h3 className="text-lg font-semibold text-gray-700 mb-4">
            {sectionLabels[sectionKey as keyof typeof sectionLabels]}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
            {fields.map((field) => renderField(field, control))}
          </div>
        </div>
      ))}
    </>
  );
}
